export default __webpack_public_path__ + "static/media/CarteroW01-Light.549ad115.ttf";